/**
 * @description Ações relacionadas a manipulação de sessões no sistema
 * @author Bene Lemuel Dantas Gondim
 * @file sessionActions.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */
import axios from 'utils/axios'

export const SESSION_LOGIN_SUCESSO = 'SESSION_LOGIN_SUCESSO'
export const RENEW_SESSION_SUCESSO = 'RENEW_SESSION_SUCESSO'
export const SESSION_LOGIN_CPF_SENHA_INCORRETOS_ERROR = 'SESSION_LOGIN_CPF_SENHA_INCORRETOS_ERROR'
export const SESSION_LOGIN_ERRO_LOGIN_ERROR = 'SESSION_LOGIN_ERRO_LOGIN_ERROR'
export const SESSION_LOGOUT_SUCESSO = 'SESSION_LOGOUT_SUCESSO'
export const SESSION_LOGOUT_TOKEN_EXPIRADO_SUCESSO = 'SESSION_LOGOUT_TOKEN_EXPIRADO_SUCESSO'

export const setSession = (data) => async (dispatch) => {
  dispatch({
    type: SESSION_LOGIN_SUCESSO,
    token: data.token,
    usuario: data.usuario,
  })
}

export const setLocalStorage = (token) => {
  localStorage.setItem('@sigep/token', token)
}

export const login = ({ cpf, senha }) => axios.post('/auth/autenticar/local/', { cpf, senha })

export const logoutTokenExpirado = (router) => async (dispatch) => {
  dispatch(
    {
      type: SESSION_LOGOUT_TOKEN_EXPIRADO_SUCESSO,
    },
    localStorage.removeItem('@sigep/token'),
    localStorage.removeItem('@sigep/state'),
    router.history.push(`/auth/login`)
  )
}
